import { createReducer } from '@reduxjs/toolkit';
import { DAMS_GET_ALL, DAMS_GET_BY_NAME } from './action';
import { Dam } from 'src/types/dam';

export type DamsState = {
  dams: Dam[];
  filterDams: Dam[];
};

export const initialState: DamsState = {
  dams: [],
  filterDams: [],
};

const damReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(DAMS_GET_ALL, (state, action) => {
      state.dams = action.payload.dams;
    })
    .addCase(DAMS_GET_BY_NAME, (state, action) => {
      state.filterDams = action.payload.dams;
    })
);

export default damReducer;
